import { LoadingPage } from "@/component-nextv3/LoadingPage";
import { useResponsive } from "@/core-nextv3/util/useResponsive";
import { AUTH_SETTING, REVALIDATE_SETTING } from "@/setting/setting";
import type { GetStaticProps } from "next";
import { useTranslation } from "next-i18next";
import { useContext, useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { AuthContext } from "../context/AuthContext";
import { useProtectedAuthMeta } from "../context/useProtectedAuthMeta";
import withHeader from "../utils/withHeader";
import styles from "./styles.module.scss";

const PerfilPage = () => {
	const { t } = useTranslation();
	const { user } = useContext<any>(AuthContext);
	const [passwordType, setPasswordType] = useState("password");
	const { isClient } = useResponsive();

	const loadProtectedAuth = useProtectedAuthMeta(AUTH_SETTING, "", "/");

	if (!loadProtectedAuth) {
		return <LoadingPage />;
	}

	if (!isClient) {
		return <></>;
	}

	return (
		<div className={styles.perfilPage}>
			<div className={styles.content}>
				{/* <h1>{t("Informações do Membro")}</h1> */}
				<h1>{t("회원정보")}</h1>

				<div className={styles.tableInformation}>
					<div className={styles.information}>
						<p className={styles.left}>{t("id")}</p>
						<p className={styles.right}>{user?.code}</p>
					</div>

					<div className={styles.information}>
						<p className={styles.left}>{t("Senha")}</p>
						<div className={styles.right}>
							<div className={styles.input}>
								<input type={passwordType} placeholder={t("Senha")} disabled />
								{passwordType === "password" ? (
									<AiOutlineEye
										className={styles.iconPassword}
										onClick={() => setPasswordType("text")}
									/>
								) : (
									<AiOutlineEyeInvisible
										className={styles.iconPassword}
										onClick={() => setPasswordType("password")}
									/>
								)}
							</div>
							{/* <span> - Please enter in when editing</span> */}
						</div>
					</div>

					<div className={styles.information}>
						<p className={styles.left}>{t("Confirme sua senha")}</p>
						<div className={styles.right}>
							<div className={styles.input}>
								<input type={passwordType} placeholder={t("Senha")} disabled />
								{passwordType === "password" ? (
									<AiOutlineEye
										className={styles.iconPassword}
										onClick={() => setPasswordType("text")}
									/>
								) : (
									<AiOutlineEyeInvisible
										className={styles.iconPassword}
										onClick={() => setPasswordType("password")}
									/>
								)}
							</div>
							{/* <span> - Please enter in when editing</span> */}
						</div>
					</div>

					<div className={styles.information}>
						<p className={styles.left}>{t("Nome")}</p>
						{/* <p className={styles.right}>{user?.name.replace(/^(.*?)\s/, "$1***")}</p> */}
						<p className={styles.right}>
							{user?.name.length > 2
								? user?.name.replace(/^(.{2}).*/, "$1*")
								: user?.name.replace(/^(.{1}).*/, "$1*")}
						</p>
					</div>

					<div className={styles.information}>
						<p className={styles.left}>{t("Banco")}</p>
						<p className={styles.right}>{user?.bank?.label}</p>
					</div>

					<div className={styles.information}>
						<p className={styles.left}>계좌번호</p>
						<p className={styles.right}>
							{user?.accountNumber?.slice(0, user?.accountNumber.length / 3)}
							{"*".repeat(user?.accountNumber.length / 3)}
							{user?.accountNumber.slice(
								(user?.accountNumber.length / 3) * 2,
								user?.accountNumber.length,
							)}
						</p>
					</div>

					<div className={styles.information}>
						<p className={styles.left}>{t("Nickname")}</p>
						<p className={styles.right}>{user?.nickname}</p>
					</div>

					<div className={styles.information}>
						<p className={styles.left}>{t("Numero de telefone")}</p>
						<p className={styles.right}>
							{user?.phone.replace(/\d{4}(?=-)/, "****")}
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

const getStaticProps: GetStaticProps = ({ locale }: any) =>
	withHeader(async (_props: any) => {
		return {
			props: {
				locale: locale,
			},
			revalidate: REVALIDATE_SETTING,
		};
	});
export { getStaticProps as GetStaticProps, PerfilPage };
